import GettingStarted from './GettingStarted';

export default GettingStarted;
